import styled from "styled-components";

export const CardDiv = styled.li`
  background-color: var(--white);
  padding: var(--insidePadding);
  border: 1px solid var(--rule);
  margin-bottom: var(--insidePadding);
  /* max-width: var(--maxCardWidth); */
  width: var(--cardWidth);
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.125);
  & h2 {
    margin: 0 0 var(--insidePadding) 0;
    font-size: 18px;
    display: flex;
    & a {
      color: var(--text);
      text-decoration: none;
      &:hover {
        color: var(--highlight);
      }
    }
    & span {
      font-size: 14px;
      margin-right: 8px;
      white-space: nowrap;
      font-family: var(--headerFont);
      font-weight: normal;
    }
  }
  & > a {
    display: block;
    line-height: 0;
  }
`;
